<template>
  <span class="block !mb-2 !mt-1 !h-2 w-full skeleton-light"></span>
  <span class="block !mb-2 !mt-1 !h-2 w-[200px] skeleton-light"></span>
  <div class="w-full flex items-center justify-between !mt-4">
    <div v-for="index in 5" :key="index" class="feedback-item flex flex-col items-center cursor-pointer">
      <div class="flex items-center justify-center rounded-[20px] !w-[40px] !h-[40px] !mb-2 skeleton-light"></div>
      <span class="w-[45px] !h-3 skeleton-light"> </span>
    </div>
  </div>
</template>
